import React, { useEffect } from 'react';
import '../../assets/styles/Notification.css'; 

const Notification = ({ message, isError, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        },3000); 

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`notification-holder ${isError ? 'error-holder' : 'success-holder'}`}>
            <span>{message}</span>
            <button className="close-button-holder" onClick={onClose}>&times;</button>
        </div>
    );
};

export default Notification;
